import { render } from "./PathNotFound.vue?vue&type=template&id=65abf0d4"
import script from "./PathNotFound.vue?vue&type=script&lang=js"
export * from "./PathNotFound.vue?vue&type=script&lang=js"

import exportComponent from "/Users/pmerkuloff/Web/hlv/FRONT/hpanel/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__